import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=2472c478&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"
import style0 from "./Compliance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ComplianceInsuranceTab: require('/codebuild/output/src2428694706/src/cc-portal/components/ComplianceInsuranceTab.vue').default,ComplianceFinanceTab: require('/codebuild/output/src2428694706/src/cc-portal/components/ComplianceFinanceTab.vue').default})
